import React, { useEffect } from "react";

function AdsTxtContent() {
  useEffect(() => {
    // Redirect to the actual app-ads.txt file
    window.location.href = "/app-ads.txt";
  }, []);

  return (
    <div>
      <p>Redirecting to app-ads.txt...</p>
    </div>
  );
}

export default AdsTxtContent;